// Souches de numérotation des documents (MOCKED localStorage).
// L'Administrateur définit préfixe + numéro de départ pour enchaîner avec son ancienne comptabilité.
const CFG_KEY = 'oliva.souches';
const ATTRIB_KEY = 'oliva.numeros';

export const TYPES_DOC = [
  { id: 'facture', label: 'Facture officielle', hint: 'Ventes et prestations facturées' },
  { id: 'bon_reception', label: 'Bon de réception (olives)', hint: 'Décomptes et bons de pesée à l’entrée' },
  { id: 'bon_pesee', label: 'Bon de pesée / sortie', hint: 'Sorties grignons, huile, produits finis' },
  { id: 'recu_paiement', label: 'Reçu de paiement / avance', hint: 'Caisse, avances et règlements de tiers' },
  { id: 'ordre_fabrication', label: 'Ordre de fabrication', hint: 'Feuille de route de l’atelier (planning de trituration)' },
  { id: 'piece_caisse', label: 'Pièce de caisse', hint: 'Alimentations, dépenses et transferts (auto si aucune pièce saisie)' },
  { id: 'bon_vente', label: 'Bon de vente', hint: 'Ventes gros et comptoir (numéro attribué à chaque vente)' },
  { id: 'bon_sortie', label: 'Bon de sortie d’huile', hint: 'Retraits d’huile des clients prestation stockée en cuve' },
];

export const SOUCHES_DEFAUT = {
  facture: { prefixe: 'FAC-2026-', depart: 1, longueur: 4 },
  bon_reception: { prefixe: 'BR-2026-', depart: 1, longueur: 4 },
  bon_pesee: { prefixe: 'BP-2026-', depart: 1, longueur: 4 },
  recu_paiement: { prefixe: 'REC-2026-', depart: 1, longueur: 4 },
  ordre_fabrication: { prefixe: 'OF-2026-', depart: 1, longueur: 4 },
  piece_caisse: { prefixe: 'PC-2026-', depart: 1, longueur: 5 },
  bon_vente: { prefixe: 'BV-2026-', depart: 1, longueur: 5 },
  bon_sortie: { prefixe: 'BS-2026-', depart: 1, longueur: 4 },
};

export const getSouches = () => {
  const raw = localStorage.getItem(CFG_KEY);
  return raw ? { ...SOUCHES_DEFAUT, ...JSON.parse(raw) } : SOUCHES_DEFAUT;
};

export const setSouches = (v) => localStorage.setItem(CFG_KEY, JSON.stringify(v));

const lireAttributions = () => JSON.parse(localStorage.getItem(ATTRIB_KEY) ?? '{}');

export const formaterNumero = (souche, n) =>
  `${souche.prefixe}${String(n).padStart(Number(souche.longueur) || 1, '0')}`;

// Prochain numéro qui sera attribué pour ce type de document.
export const prochainNumero = (typeDoc) => {
  const souche = getSouches()[typeDoc] ?? SOUCHES_DEFAUT[typeDoc];
  const attrib = lireAttributions()[typeDoc] ?? {};
  const compteurs = Object.values(attrib).map((a) => a.sequence);
  const suivant = compteurs.length ? Math.max(...compteurs) + 1 : Number(souche.depart) || 1;
  return { numero: formaterNumero(souche, suivant), sequence: suivant, souche };
};

// Attribue (une seule fois) un numéro unique et incrémental à un document.
// La même référence métier réimprimée conserve son numéro.
export const attribuerNumero = (typeDoc, refMetier) => {
  const toutes = lireAttributions();
  const parType = toutes[typeDoc] ?? {};
  if (parType[refMetier]) return parType[refMetier].numero;
  const { numero, sequence } = prochainNumero(typeDoc);
  parType[refMetier] = { numero, sequence, horodatage: new Date().toISOString() };
  localStorage.setItem(ATTRIB_KEY, JSON.stringify({ ...toutes, [typeDoc]: parType }));
  return numero;
};

export const numeroAttribue = (typeDoc, refMetier) =>
  lireAttributions()[typeDoc]?.[refMetier]?.numero ?? null;

export const compterDocuments = (typeDoc) => Object.keys(lireAttributions()[typeDoc] ?? {}).length;
